import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import menuItems from '../../config/menu.json';
import { MenuItem } from '@/models/menu.interface.js';
@Module
export default class SidebarStore extends VuexModule {
  /* tslint:disable */
  private _sideBarOpened: boolean = true;
  private _menuItems: Array<MenuItem> = menuItems;
  /* tslint:enable */

  @Mutation public toggleSidebarMut() {
    this._sideBarOpened = !this._sideBarOpened;
  }

  @Mutation public activeMenuItemMut(label: string) {
    this._menuItems.forEach((menu: MenuItem) => {
      menu.isActive = menu.label === label ? true : false;
    });
  }

  @Action({ commit: 'toggleSidebarMut' }) public toggleSideBarAction(): void {
    return;
  }

  @Action({ commit: 'activeMenuItemMut' }) public activeMenuItemAction(item: string): string {
    return item;
  }

  get sideBarOpened(): boolean {
    return this._sideBarOpened;
  }

  get menuItems(): MenuItem[] {
    return this._menuItems;
  }
}
